import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'

const AURAAgenticAIHybrid = () => {
  return (
    <>
      <Element
        name="AURAAgenticAIHybrid"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "Hybrid & Connected Agentic AI"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">Synchronized edge and cloud agents for maximum business impact.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 h-100 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/cloudlightening.svg`} alt="cloudlightening" />
                </div>
                <h5 className="mt-3 mb-3">Route Optimization</h5>
                <p className="mb-0">Edge AI agents collaborate with cloud-based models for optimal routing—combining local awareness with global insights.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/server.svg`} alt="server" />
                </div>
                <h5 className="mt-3 mb-3">Fleet Management</h5>
                <p className="mb-0">Edge devices pre-process sensor/camera data, then cloud agents coordinate asset deployment and analytics across organizations.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/hexagon.svg`} alt="hexagon" />
                </div>
                <h5 className="mt-3 mb-3">Operational Intelligence</h5>
                <p className="mb-0">Agents blend local event detection with cloud-based predictive analytics for proactive incident response.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AURAAgenticAIHybrid;